<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.5 16.2"
    aria-hidden="true"
  >
    <path
      d="M4.1 16.2c-.7 0-1.3-.1-1.9-.2l-.3-.1c-.1 0-.3-.1-.4-.3L.3 14.2c-.2-.1-.3-.3-.3-.6 0-.2.1-.4.3-.5L4 9.8c.3-.3.8-.2 1.1.1l1.2 1.4c.1.2.2.4.2.6 1.4-.3 2.7-1 3.9-2 1.3-1.1 2.4-2.3 3-3.4-.3 0-.5-.1-.5-.2l-1.2-1.4c-.2-.2-.2-.4-.2-.6 0-.2.1-.4.3-.5L16 .2c.3-.3.8-.2 1.1.1l1 1.2c.2.2.3.6.3 1 0 3.4-2.2 7.3-5.8 10.1-2.8 2.4-5.7 3.6-8.5 3.6zm-2.2-1s.1.1 0 0l.4.1c3.1.7 6.5-.5 10-3.3 3.4-2.8 5.5-6.4 5.5-9.6 0-.1 0-.4-.1-.5L16.6.7c-.1-.1-.1-.1-.2 0l-4.2 3.6v.2l1.2 1.4c.1 0 .3 0 .6-.1l.7-.2-.3.6c-.5 1.3-1.8 2.8-3.5 4.2-1.5 1.3-3.3 2.1-5 2.3l-1.1.2 1-.9v-.2l-1.2-1.4c-.1-.1-.1-.1-.2 0L.6 13.7v.2l1.3 1.3zm11.6-9.3z"
    />
  </svg>
</template>
